import { getVideoEmbed } from "@/core/utils";
import { VideoSingularFragment } from "@graphqlTypes";
import { BasicEmbed } from "./BasicEmbed";
import { YoutubeEmbed } from "./YoutubeEmbed";
import { forwardRef } from "react";
import { YTRef } from "./YoutubeEmbed/YoutubeEmbed";

type VideoEmbedProps = Omit<
  VideoSingularFragment,
  "__typename" | "headline" | "videoTitle" | "eyebrow"
> & {
  className?: string;
  autoplay?: boolean;
};

const VideoEmbed = forwardRef<YTRef, VideoEmbedProps>((props, ref) => {
  const videoEmbedData = getVideoEmbed(props);
  const { className, autoplay } = props;
  if (!videoEmbedData) return null;
  const isYoutube = videoEmbedData.isYoutube;
  return (
    <>
        { isYoutube ? (
          <YoutubeEmbed
            autoplay={autoplay}
            className={className}
            ref={ref}
            id={videoEmbedData.videoId}
          />
        ) : (
          <BasicEmbed
            className={className}
            ref={ref}
            videoUrl={videoEmbedData.videoUrl}
          />
        )
      }
    </>
  );
});

export default VideoEmbed;
